<app-sidebar>
    <router-outlet></router-outlet>
</app-sidebar>
